export default function hasKey<O>(obj: O, key: keyof any): key is keyof O {
  return key in obj;
}

export const formatNormalizedRating = rating =>
  (Math.round(rating * 10 * 5) / 10).toFixed(1);

export const formatRating = rating => rating.toFixed(1);
